import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Icon from '../../../../components/Icon';
import { TableCell, TableRow } from '@mui/material';

const ClientListSkeleton = () => (
  <>
    {[...Array(3)].map((row, i) => (
      <TableRow key={i}
        >
        <TableCell align="center">
          <Skeleton borderRadius="50%" height="50px" width="50px" margin="0" />


        </TableCell>
        <TableCell align="left">
          <Skeleton borderRadius="1rem" height="30px" width="90%" margin="0" />

        </TableCell>
        <TableCell align="left">
          <Skeleton borderRadius="1rem" height="30px" width="90%" margin="0" />

        </TableCell>
        <TableCell align="left">
          <Skeleton borderRadius="1rem" height="30px" width="90%" margin="0" />

        </TableCell>
        <TableCell align="center" style={{ width: '500px' }}>
          <div className="row-flex align-center justify-center column-gap-20">
            <Skeleton borderRadius="50%" height="30px" width="30px" margin="0" />
            <Skeleton borderRadius="50%" height="30px" width="30px" margin="0" />
            <Skeleton borderRadius="50%" height="30px" width="30px" margin="0" />
          </div>
        </TableCell>

        <TableCell align="center">
          <Skeleton borderRadius="1rem" height="30px" width="90%" margin="0" />
        </TableCell>

        <TableCell align="center" style={{ width: '60px' }}>
          <div style={{ position: 'relative', left: '0', textAlign: 'left' }}>
            <Skeleton borderRadius="50%" height="30px" width="30px" margin="0" />
          </div>

        </TableCell>
      </TableRow>
    ))}
  </>
);


export const EmptyData = () => (
  <>
    <TableCell id="tableHeader">
      <div
        className="row-flex column-gap-16 align-center justify-center"
                   >
        <label className="margin-0" />
        <Icon classNames="size-25 custom_icon_size" />
      </div>
    </TableCell>

    <TableCell id="tableHeader">
      <div
        className="row-flex column-gap-16 align-center justify-center"
                   >
        <label className="margin-0" />
        <Icon classNames="size-25 custom_icon_size" />
      </div>
    </TableCell>
    <TableCell id="tableHeader">
      <div
        className="row-flex column-gap-16 align-center justify-center"
                   >
        <label className="margin-0" />
        <Icon classNames="size-25 custom_icon_size" />
      </div>
    </TableCell>
    <TableCell id="tableHeader">
      <div
        className="row-flex column-gap-16 align-center justify-center"
                   >
        <label className="margin-0" />
        <Icon classNames="size-25 custom_icon_size" />
      </div>
    </TableCell>
    <TableCell id="tableHeader">
      <div
        className="row-flex column-gap-16 align-center justify-center"
                   >
        <label className="margin-0" />
        <Icon classNames="size-25 custom_icon_size" />
      </div>
    </TableCell>
  </>
);
export default ClientListSkeleton;
